import React from 'react';
import http from '../api';
import PopupFrameV2 from '../popup/PopupFrameV2';
import Button from './Button';

export class ShopGptAnalisysLoadingPopup extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
        }
    }

    componentWillMount() {
    }

	componentDidMount() {
    
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    render() {
        return (
            <div>
                <div className="ShopGptAnalisysLoadingPopup" style={{position:"fixed", zIndex: 99999}}>
                    <PopupFrameV2
                            className={"ShopGptAnalisysLoadingPopupFrame"}
                            width={"auto"}
                            maxWidth={"90vw"}
                            // height={"90vh"}
                            maxHeight={"90vh"}
                            padding={"40px 0px 0px 0px"}
                            onClose={() => {
                                this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                            }}
                        >
                        <div className="flexBox" style={{flexDirection:'column', flexWrap:"nowrap", height:"100%", textAlign:"center", alignItems: "center"}}>
                            <div className="flexBox" style={{flex:"1", flexDirection:'column', flexWrap:"nowrap", textAlign:"center", alignItems: "center", padding:"0px 40px 50px 40px"}}>
                                <div style={{display:"flex", alignItems: "center"}}>
                                    <img className="logo" src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/0e962a7a54a126f4e37dde4810da9e4f7ad6f91e.png" style={{width:"100px", height:"auto"}}/>
                                    <div style={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
                                        <div className="title" style={{fontWeight: "700", fontSize: "18px", fontFamily:"Roboto Flex", marginRight:"80px"}}>
                                            잠시만요~<br/>
                                            아직 분석하는 중이에요.<br/>
                                            조금만 기다려주세요....
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PopupFrameV2>
                </div>
            </div>
        )
    };
}